import api from "@/api/session";
import {computed, ref} from "vue";
import i18n from "@/i18n";
import { useProfiles } from '@/composable/useUsers';

const myOwnedSession = {
  isActiveWorkspace: false,
  isDefault: true,
  id: '',
  title: i18n.global.t('myWorkspace')
}

const {fetchProfiles, mappedProfiles} = useProfiles()

const sessions = ref([])

export function useSession() {
  const fetchSessions = async () => {
    const result = await api.fetch()
    const ownerIds = result.reduce((acc, item) => {
      acc.push(item.ownerId)
      return acc
    }, [])

    if(ownerIds.length){
      await fetchProfiles({ usersId: ownerIds })
    }

    const formattedList = result.map((e) => {
      const {firstName, lastName, avatarLink} = mappedProfiles.value[e.ownerId]
      return {
        ...e,
        isDefault: false,
        firstName,
        lastName,
        avatarLink
      }
    })
    sessions.value = [myOwnedSession, ...formattedList]
  }

  const updateSession = async (params) => {
    try {
      await api.update(params)
      replaceCacheItem(params)
    }catch (err){
      console.log(err);
    }
  }

  const replaceCacheItem = (params) => {
    const index = sessions.value.findIndex(e => e.id === params.workspaceId)
    const currentItem = sessions.value.find(e => e.id === params.workspaceId)
    currentItem.isActiveWorkspace = true
    sessions.value.splice(index, 1, currentItem)
  }

  const currentSession = computed(() => {
    return sessions.value.find(e => e.isActiveWorkspace)
  })

  return {
    fetchSessions,
    sessions,
    currentSession,
    updateSession
  }
}
